import { moveTimeStreamAsset, moveTimeStreamAssetToPosition } from '../actions';
import { orchestrator } from 'satcheljs';
import patchAsset from '../utils/patchAsset';

orchestrator(moveTimeStreamAsset, ({ projectId, assetId, x, y, dx, dy, partialOriginalAsset }) => {
    // Patch the asset only if there was an effective movement and the given position represent the current position, and not under a bucket.
    const isCapturedProps = partialOriginalAsset.isCaptured ? { isCaptured: false } : undefined;
    patchAsset(
        projectId,
        assetId,
        { x, y, ...isCapturedProps },
        partialOriginalAsset,
        asset =>
            (dx != 0 || dy != 0) && asset.bounds.x == x && asset.bounds.y == y && !asset.parentId
    );
});

orchestrator(
    moveTimeStreamAssetToPosition,
    ({ projectId, assetId, x, y, partialOriginalAsset, onlySetLocally }) => {
        const isCapturedProps = partialOriginalAsset.isCaptured ? { isCaptured: false } : undefined;
        patchAsset(
            projectId,
            assetId,
            { x, y, ...isCapturedProps },
            partialOriginalAsset,
            asset =>
                !onlySetLocally && asset.bounds.x == x && asset.bounds.y == y && !asset.parentId
        );
    }
);
